export const AccountNegativeKeywordList = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Account Negative Keyword List',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent Id',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
  },
};
